import { tsrContractsClient } from './tsrContractsClient';

const documentServiceClient = () => tsrContractsClient.apiV1Contract.document;

export { documentServiceClient };
